var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeams(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4a4 4 0 014-4h36a4 4 0 014 4v36a4 4 0 01-4 4H4a4 4 0 01-4-4V4z",
    fill: "#E2E2F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.22 19.833h-5.517l-1.539 1.245v6.174a4.15 4.15 0 108.3 0v-6.174c0-.687-.556-1.245-1.244-1.245zM35.5 15.857a2.652 2.652 0 11-5.304 0 2.652 2.652 0 015.303 0z",
    fill: "#5059C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.447 19.837h9.551c.658 0 1.19.533 1.19 1.19v7.547a5.846 5.846 0 01-5.846 5.847h-.239a5.846 5.846 0 01-5.847-5.847v-7.546c0-.658.533-1.191 1.191-1.191zM28.746 14.533a3.854 3.854 0 11-7.708 0 3.854 3.854 0 017.708 0z",
    fill: "#7B83EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.22 18.085v-.903c0-.73-.627-1.326-1.392-1.326h-3.553a3.845 3.845 0 003.592 2.486c.477 0 .93-.098 1.352-.257zm-7.964 2.942c0-.658.533-1.19 1.19-1.19h6.773v10.387c0 .73-.82 1.54-1.664 1.54h-5.343a5.807 5.807 0 01-.956-3.19v-7.547z",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.31 30.438a1.33 1.33 0 01-1.327-1.325V15.855c0-.73.597-1.326 1.326-1.326h13.258c.73 0 1.326.597 1.326 1.326v13.258a1.33 1.33 0 01-1.326 1.325H10.309z",
    fill: "#4B53BC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.915 19.837h-2.87v7.716h-1.887v-7.716h-2.886v-1.895h7.643v1.895z",
    fill: "#fff"
  })));
}
export default SvgTeams;